
import { HumanFilter, HumanFilterOperation } from "@/utils/human-filter";
import AppHumanFilterEditValue from "@/components/models/HumanFilterEditValue.vue";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

const OPERATORS:HumanFilterOperation[] = ["=", "!=", "like", "!like", "^", "!^", "$", "!$"];

export default Vue.extend({
	data(){
		return {
			ready: false,
			valueFilter: new HumanFilter()
		};
	},
	props: {
		value: {
			type: Object as ()=>HumanFilter,
			required: true
		}
	},
	computed: {
		operators(): ISelectItem<string>[] {
			return OPERATORS.map((op) => {
				return {
					text: this.$t("common.filters." + HumanFilter.getTranslationOperator(op)).toString(),
					value: op
				};
			});
		},
	},
	watch: {
		valueFilter: {
			deep: true,
			handler(){
				this.value.Values = this.valueFilter.Values;
			}
		},
	},
	methods: {
		setOperator(event:HumanFilterOperation){
			this.value.Options[0] = event;
			this.valueFilter.Operator = event;
			this.value.Operator = event;
		}
	},
	mounted(){
		if (!this.value.Operator) {
			this.value.Operator = (this.value.Options[0] as HumanFilterOperation) || "=";
		}
		this.value.Options[0] = this.value.Operator;
		this.valueFilter.Operator = this.value.Operator;
		if (this.value.Values.length == 0) {
			this.value.Values.push("");
		}
		this.valueFilter.Values = this.value.Values;
		this.ready = true;
	},
	components: {
		AppHumanFilterEditValue
	},
	i18nEx: {
		componentPrefix: "components.models"
	}
});
